import { useState, useEffect } from 'react';
import { NewRequestForm } from 'Components';
import { useAllCategories, useProjectDetails } from 'Hooks';
import { TFunction } from 'react-i18next';


export function useNewResquestForm(t: TFunction<'forms'>, isAdmin: boolean) {
    const [newRequestForm, setNewRequestForm] = useState(NewRequestForm(t, isAdmin));

    const { projectDetails } = useProjectDetails();
    const { categories } = useAllCategories();
    
    useEffect(() => {
        setNewRequestForm(NewRequestForm(t, isAdmin)); // If weird form behaviors, might be because of this one ! :)
    }, [isAdmin, t]);


    useEffect(() => {
        setNewRequestForm(prevState => ({
            ...prevState,
            category: {
                ...prevState["category"],
                options: categories.map(category => ({ key: category.categoryId, value: category.description }))
            },
            contract: {
                ...prevState["contract"],
                options: projectDetails.map(projectDetail => ({ key: projectDetail.projectNumber, value: projectDetail.projectNumber }))
            }
        }));
    }, [setNewRequestForm, categories, projectDetails]);

    return { newRequestForm, setNewRequestForm };
}